<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-lightning";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 45 45">
			<path
				d="M10.6271 30.1456L20.3303 18.5205H12.8303L14.1896 7.87992L5.51776 20.3955H12.0334L10.6271 30.1456ZM7.72088 24.1455H1.90838C1.15838 24.1455 0.60338 23.8099 0.24338 23.1387C-0.11662 22.4674 -0.077245 21.8187 0.361505 21.1924L14.3771 1.03617C14.6896 0.598673 15.0959 0.294298 15.5959 0.123048C16.0959 -0.0482016 16.6115 -0.0407014 17.1428 0.145549C17.674 0.331799 18.0646 0.659923 18.3146 1.12992C18.5646 1.59992 18.6584 2.09992 18.5959 2.62992L17.0959 14.7705H24.3615C25.174 14.7705 25.7446 15.1299 26.0734 15.8487C26.4021 16.5674 26.3003 17.2393 25.7678 17.8643L10.3459 36.333C10.0021 36.7393 9.58026 37.0049 9.08026 37.1299C8.58026 37.2549 8.09588 37.2081 7.62713 36.9893C7.15838 36.7706 6.79151 36.4349 6.52651 35.9824C6.26151 35.5299 6.15963 35.0374 6.22088 34.5049L7.72088 24.1455Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 45 45"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
